class Tooltip extends HTMLElement {
  connectedCallback() {
    this.setup()
  }

  handleDropdownPosition() {
    const screenPadding = 16

    const placeholderRect = this.placeholder.getBoundingClientRect()
    const dropdownRect = this.dropdown.getBoundingClientRect()

    const dropdownRightX = dropdownRect.x + dropdownRect.width
    const placeholderRightX = placeholderRect.x + placeholderRect.width

    if (dropdownRect.x < 0) {
      this.dropdown.style.left = '0'
      this.dropdown.style.right = 'auto'
      this.dropdown.style.transform = `translateX(${
        -placeholderRect.x + screenPadding
      }px)`
    } else if (dropdownRightX > window.outerWidth) {
      this.dropdown.style.left = 'auto'
      this.dropdown.style.right = '0'
      this.dropdown.style.transform = `translateX(${
        window.outerWidth - placeholderRightX - screenPadding
      }px)`
    }
  }

  toggle(e) {
    e.preventDefault()
    e.stopPropagation()
    dismissAllTooltips(e)
    if (this.classList.contains('tooltip--open')) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.classList.add('tooltip--open')
    this.handleDropdownPosition()
  }

  close() {
    this.classList.remove('tooltip--open')
  }

  setup() {
    this.placeholder = this.querySelector('.tooltip-label')
    this.dropdown = this.querySelector('.tooltip-dropdown')

    this.placeholder.addEventListener('mouseover', () =>
      this.handleDropdownPosition()
    )
    this.placeholder.addEventListener('touchstart', (e) => this.toggle(e))
  }
}

function dismissAllTooltips(event) {
  const currentTooltip = event.target.closest('vp-tooltip')
  for (const tooltip of document.querySelectorAll('.tooltip--open')) {
    if (tooltip === currentTooltip) continue
    tooltip.classList.remove('tooltip--open')
  }
}

customElements.define('vp-tooltip', Tooltip)
document.addEventListener('touchstart', (e) => dismissAllTooltips(e))
